module.exports = "<select #selector>\n  <ng-content select=\"option, optgroup\">\n  </ng-content>\n</select>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/ng-select2/ng-select2/ng-select2.component.html
// module id = ../../../../ng-select2/ng-select2/ng-select2.component.html
// module chunks = 4